import React, { useEffect, useState, useCallback } from 'react';
import { Amplify } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';
import "../../src/styles/header.css";

import BRAND_LOGO from '../images/home-logo.png';

import SoundEnabled from '../images/sound_enabled.png';
import Settings from '../images/Settings.png';
import EmailNotification from '../images/email_notification.png';

import { optEmail } from '../redux/actions/optEmail';
import { fetchUser } from '../redux/actions/fetchUser';
import { businessTokenMapping } from '../redux/actions/businessTokenMappingActions';

import awsconfig from '../aws-exports';

import NotifBoard from './notif/NotifBoard';
import {newFeature} from '../redux/actions/newFeature';
import NotificationBellIcon from '../images/NotificationBellIcon.png';

// Import images
import HealthInfoIcon from '../images/Health Info.png';
import ReportingIcon from '../images/Reporting.png';
import LifecycleIcon from '../images/Lifecycle.png';
import UserManagementIcon from '../images/User Management.png';
import AdminIcon from '../images/Admin.png';
import SiteIcon from '../images/Sites.png';
import LicenseIcon from '../images/Licenses.png';
import ResourcesIcon from '../images/Resources.png';
import SamuraiIconSmall from '../images/Samurai.svg';

// Import generic components
import UserDropDown from '../generic_components/UserDropDown/UserDropDown';
import Avatar from '../generic_components/Avatar/Avatar';
import Tooltip from '../generic_components/Tooltip/Tooltip';
import Button from '../generic_components/Button/Button';
import Modal from '../generic_components/Modal/Modal';
import SideBarMobile from '../generic_components/SideBarMobile/SideBarMobile';


Amplify.configure(awsconfig);

const MyNavbar = ({ isSmallScreen, soundEnabled, setSoundEnabled }) => {
  const [user, setUser] = useState(localStorage.getItem('email'));
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [checkOptOutEmail, setCheckOptOutEmail] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showLogoutSmall, setShowLogoutSmall] = useState(false);
  const [showLogoutWarningModal, setShowLogoutWarningModal] = useState(false);

  const emailOptResponse = useSelector(state => state.optemail);

  const businessTokenMappingData = useSelector(state => state.businessTokenMapping);
    
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let toolTipEmptyNotification = "No notifications";

  // Logged in modal
  const handleCloseLogout = () => {
    setShowLogout(false);    
  } 

  const handleShowLogout = () => {   
    setShowLogout(true);    
  }

  // Logged in modal for small screen
  const handleCloseLogoutSmall = () => {
    setShowLogoutSmall(false);    
  } 

  const handleShowLogoutSmall = () => {   
    setShowLogoutSmall(true);    
  }


  // logged out warning modal
  const handleCloseLogoutWarning = () => {
    setShowLogoutWarningModal(false);
  } 
  const handleShowLogoutWarning = () => {
    setShowLogoutWarningModal(true);  }


  // Logout user
  const logout = useCallback(() => { 
    setShowLogout(false);
    setShowLogoutWarningModal(false);
    setShowLogoutSmall(false);
    localStorage.clear();
    navigate('/');  
    setUser('');  
  }, [navigate]);

  // Handle open/close settings modal
  const handleOpenSettingsModal = () => {
    setShowSettingsModal(prev => !prev);
  };

  const handleCloseSettingsModal = () => {
    setShowSettingsModal(false);
  }

  // Dispatch email opt-out submission to the backend
  const handleOptEmail = (e) => {    
    setCheckOptOutEmail(e.target.checked);
    
    if (emailOptResponse.msg !== 201) {
      dispatch(optEmail({optEmail: 0, user: user}));
    }
    else {
      dispatch(optEmail({optEmail: 1, user: user}));
    }
  };

  // Handle toggling of audio switch
  const handleToggleEnableAudio = async() => {
    setSoundEnabled(prev => !prev);
  };

  useEffect(() => {
    dispatch(optEmail({ optEmail: 2, user: user }));
  }, [user, dispatch]);

  useEffect(() => {
    if (emailOptResponse.msg === 404) {
      setCheckOptOutEmail(false);
    }
    else {
      setCheckOptOutEmail(true);
    }
  }, [emailOptResponse]);

  useEffect(() => {
    if (user)
      dispatch(businessTokenMapping({user: user}));
  }, [user, dispatch]);

  useEffect(() => {
    setUser(localStorage.getItem('email'));

  }, [navigate]);

  useEffect(() => {
    dispatch(fetchUser(user));
  }, [user, dispatch]);
  
  // Fetch the new features
  useEffect(() => {
    const email = localStorage.getItem('email');
    dispatch(newFeature(email));
  }, [dispatch]);


  // Handle notification dashboard
  const [openNotifDashboard, setOpenNotifDashboard] = useState(false);
  const newFeatures = useSelector(state => state.features);
  const [numVisibleNotifications, setNumVisibleNotifications] = useState(0);

  // Calculate the visible notifications count on page load or notifications update
  useEffect(() => {
    if (newFeatures && newFeatures.length > 0) {
      const currentDate = new Date();
      const countVisibleNotifications = newFeatures.filter((feature) => {
        const releaseDate = new Date(feature.release_date);
        const diffInMonths = (currentDate - releaseDate) / (1000 * 3600 * 24 * 30); // Convert milliseconds to months
        return diffInMonths < 1 && feature.category === 'feature'; // Only show notifications that are not older than 1 months
      }).length;
      setNumVisibleNotifications(countVisibleNotifications);
      
      if(countVisibleNotifications === 0) {
        setOpenNotifDashboard(false);
      }
    }
    else {
      setNumVisibleNotifications(0);
      setOpenNotifDashboard(false);
    }
  }, [newFeatures]);

  // Get user role for Hamburger
  let userRole = localStorage.getItem('rbac_role')?.toLowerCase();
  if (!userRole || userRole === 'null') {
      try {
        // Get the highest user level
          const businessRoles = JSON.parse(localStorage.getItem('rbac_data')) || [];
          const rolePriority = ['technician', 'supervisor', 'admin', 'tla'];
          for (let i = rolePriority.length - 1; i >= 0; i--) {
              const match = businessRoles.find(b => b.role.toLowerCase() === rolePriority[i]);
              if (match) {
                  userRole = rolePriority[i];
                  break;
              }
          }
      } catch (e) {
          console.error('Error parsing rbac_data:', e);
          userRole = null;
      }
  };

  const menuItems = [
    { 
        id: 'health-info', 
        label: 'Health Info', 
        icon: <img src={HealthInfoIcon} alt='HealthInfoIcon'/>, 
        path: '/health',
    },
    { 
        id: 'report', 
        
        label: 'Reporting', 
        icon: <img src={ReportingIcon} alt='ReportingIcon'/>, 
        path: '/report' 
    },
    { 
        id: 'lifecycle', 
        label: 'Asset Lifecycle', 
        icon: <img src={LifecycleIcon} alt='LifecycleIcon'/>, 
        path: '/lifecycle' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: <img src={UserManagementIcon} alt='UserManagementIcon'/>, 
        path: '/admin', 
        allowedRoles: ['tla', 'admin', 'supervisor'] 
    },
    {
        id: 'admin', 
        label: 'Admin', 
        icon: <img src={AdminIcon} alt='AdminIcon'/>,
        allowedRoles: ['tla', 'admin', 'supervisor', 'technician'], 
        submenu: [
            {
                id: 'licenses',
                label: 'Licenses',
                icon: <img src={LicenseIcon} alt='LicenseIcon'/>,
                path: '/licenses',
            },
            {
                id: 'sites',
                label: 'Sites',
                icon: <img src={SiteIcon} alt='SiteIcon'/>,
                path: '/sites',
            }
        ]
    },
    {
        id: 'resources', 
        label: 'Resources', 
        icon: <img src={ResourcesIcon} alt='ResourcesIcon'/>,
        submenu: [
            {
                id: 'downloads-faq',
                label: 'Downloads & FAQs',
                icon: <i className="fa-solid fa-download" style={{color: "#ffffff"}}></i>,
                path: '/faq',
            },
            {
                id: 'videos',
                label: 'Videos',
                icon: <i className="fa-solid fa-video" style={{color: "#ffffff"}}></i>,
                path: '/videos',
            }
        ]
    },
  ];


  return (
    <div className='nav-container'>  
      {! isSmallScreen ?
        <>
         {/* for large screens */}
        <ul className='header-ul'>
          {user ? (
            <>
              <li key="notif" style={{ marginTop: '1%', marginRight: '1.2rem' }}>
                  <div className="bell-container">
                    {(numVisibleNotifications === 0) ?  
                      <Tooltip content={ toolTipEmptyNotification } placement="bottom" tooltipStyle={{background: 'transparent', color: '#F89532', marginTop: '-10px'}}>
                        <img src={NotificationBellIcon} alt="Bell Icon" className="bell-icon" />
                      </Tooltip>
                      :
                      <img src={NotificationBellIcon} alt="Bell Icon" className="bell-icon" onClick={()=>setOpenNotifDashboard(!openNotifDashboard)} />
                      }
                    <div className="bell-icon-badge">{numVisibleNotifications}</div>
                  </div>
                  {openNotifDashboard && <NotifBoard />}

              </li> 

              <li key="optOut" style={{ marginRight: '1.2rem', marginTop: '1.4%' }}>
                <Tooltip content={ "Settings" } placement="bottom" tooltipStyle={{background: 'transparent', color: '#F89532', marginTop: '-10px'}}>
                  <button type='text' onClick={handleOpenSettingsModal} className='mute-btn'>
                    <img alt='Settings' className='settings-icon' src={ Settings }></img>
                  </button>
                </Tooltip>
              </li>
          
              <li key="avatar" style={{ marginTop: '1%', marginRight: '1.2rem' }}>
                <button className="avatar-btn" onClick={() => handleShowLogout()}>
                  <Avatar email={user} className="avatar-circle"/>
                </button>
              </li>
            </>
          ):
          <li>
            <a href='/#auth/signin' className='login-link'>Login</a>
          </li>        
          }
        </ul>
        
        {/* modal to view logged in modal */}
        <UserDropDown             
            email={user} 
            businessTokenMappingData={businessTokenMappingData}
            show={showLogout}
            onHide={handleCloseLogout}
            onLogout={handleShowLogoutWarning}
            enableCopy
            size='sm'
            position='top-end'
            style={{ marginTop: '3%' }}
        />
        </> 
      : 
      // for small screens
      (
        <>
          <SideBarMobile 
            menuItems={menuItems}
            headerLogo={SamuraiIconSmall}
            logo={BRAND_LOGO}
            userRole={userRole}
          />

          {user ?
          <div className="bell-and-mute-container">
              <div className="bell-container">
                {(numVisibleNotifications === 0) ?  
                  <Tooltip content={ toolTipEmptyNotification } placement="bottom" tooltipStyle={{background: 'transparent', color: '#F89532', top: '40%'}}>
                    <img src={NotificationBellIcon} alt="Bell Icon" className="bell-icon-small" />
                  </Tooltip>
                  :
                  <img src={NotificationBellIcon} alt="Bell Icon" className="bell-icon-small" onClick={()=>setOpenNotifDashboard(!openNotifDashboard)} />
                  }
                <div className="bell-icon-badge">{numVisibleNotifications}</div>
              </div>

              {openNotifDashboard && <NotifBoard />}

              <div key="optOut">
                <button type='text' onClick={handleOpenSettingsModal} className='mute-btn'>
                  <img alt='Settings' className='settings-icon' src={ Settings }></img>
                </button>
              </div>

              <div className='avatar-smallscreen-container'>
                <button className="avatar-btn" onClick={() => handleShowLogoutSmall()}>
                  <Avatar email={user} size='sm'/>
                </button>
              </div>
          </div>
          :
            <a href='/#auth/signin' className='user-icon-signin'>
              <i className="fa-regular fa-user"></i>
            </a>
        }
        </>
        )
      }

      {/* modal to view logged in modal for small screen*/}
      <UserDropDown             
          email={user} 
          businessTokenMappingData={businessTokenMappingData}
          show={showLogoutSmall}
          onHide={handleCloseLogoutSmall}
          onLogout={handleShowLogoutWarning}
          enableCopy
          size='sm'
          position='top-end'
          variant='mobile'
          style={{ marginTop: '10%' }}
      />

      {/* Modal to view settings modal */}
      <Modal size='sm' show={showSettingsModal} onHide={handleCloseSettingsModal} position='top-end' style={isSmallScreen? {marginTop: '10%', marginRight: '4%'} : {marginTop: '3%', marginRight: '4%'}}>
        <Modal.Body>
          <div className="settings-header-container">
            <h4 className='settings-modal-title'>Notification Settings</h4>
            <p className='settings-modal-subtitle'>Manage your preferences and notifications</p>
          </div>

          {/* Divider */}
          <div className="settings-divider"></div>

          <div className="settings-item">
            <div className="settings-content">
                <div className="settings-info">
                    <div className="settings-title">
                        <img alt='Opt-Out Email Notifications' className='mute-icon' src={EmailNotification}></img>
                        <h3>Email Notifications</h3>
                    </div>
                    <p className="settings-description">Receive daily system health reports for your business via email</p>
                </div>
                <div className="settings-toggle-switch-container">
                  <label className="settings-toggle-switch">
                      <input 
                        type="checkbox" 
                        checked={!checkOptOutEmail}
                        onChange={(e) => handleOptEmail(e)}

                      />
                      <span className="settings-slider"></span>
                  </label>
                </div>
              </div>
          </div>

          {/* Divider */}
          <div className="settings-divider"></div>

          <div className="settings-item">
            <div className="settings-content">
                <div className="settings-info">
                    <div className="settings-title">
                        <img alt='Opt-Out Email Notifications' className='mute-icon' src={SoundEnabled}></img>
                        <h3>                            
                          Sound Alerts
                        </h3>
                    </div>
                    <p className="settings-description">Enable or disable dashboard alert sounds</p>
                </div>
                <div className="settings-toggle-switch-container">
                  <label className="settings-toggle-switch">
                      <input 
                        type="checkbox"
                        checked={soundEnabled}
                        onChange={handleToggleEnableAudio}
                      />
                      <span className="settings-slider"></span>
                  </label>
                </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal to view logged out warning modal */}
      <Modal size='sm' show={showLogoutWarningModal} onHide={handleCloseLogoutWarning} position='center'>
          <Modal.Header>           
            <Modal.Title className='header-modal-title-container'>
              <div style={{ color:'#e08a20' }}>Warning!!</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Avatar email={user}/>
            
            <div className='logout-warning-text'>                
              Are you sure you want to sign out?
            </div>

              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.5rem'}}>
                <Button
                  size='medium'
                  onClick={logout} >                     
                    Sign out
                </Button>
              </div>            
          </Modal.Body>
        </Modal>
    </div> 
  );
};

export default MyNavbar;
